<div [attr.id]="id" class="grid-panel">
  @if (!readOnly && !editOnly) {
    <div
      [attr.id]="id + '-add'"
      class="grid-panel-row"
      [ngClass]="isAddMode ? 'selected' : selectedRow !== null ? 'hidden' : ''"
      (click)="select(null)"
      >
      <div class="toggle-col">
        @if (!isAddMode) {
          <i class="fal fa-plus-circle"></i>
        }
        @if (isAddMode) {
          <i
            class="fal fa-times-circle"
            (click)="cancel($event)"
            matTooltip="Close"
            matTooltipClass="ignite-tool-tip"
            matTooltipPosition="above"
            matTooltipShowDelay="500"
          ></i>
        }
      </div>
      <div class="row-content">
        @if (!isAddMode) {
          <div id="ignite-grid-add-row" class="add-field-col">Add {{ name }}</div>
        }
        @for (col of columnsDef; track col) {
          <div
            class="header-col"
        [style.visibility]="
          isAddMode && !col.customComponent && (col.shownWhenSelected === undefined || col.shownWhenSelected) ? 'visible' : 'hidden'
        "
            [style.flex]="col.widthPercent === undefined ? '1 1 auto' : '0 0 ' + col.widthPercent + '%'"
            [style.maxWidth]="col.widthPercent === undefined ? 'auto' : col.widthPercent + '%'"
            [style.textAlign]="col.alignment === undefined ? 'auto' : col.alignment"
            >
            {{ getFieldValue(selectedRow, col.field, true) }}
          </div>
        }
      </div>
    </div>
  }

  @if (!isGridEmpty() && (showHeaderWhenItemSelected || selectedRow === null)) {
    <div [attr.id]="id + '-header'" class="grid-panel-header">
      @if (expandable) {
        <div class="spacer-col">&nbsp;</div>
      }
      <div class="row-content">
        @for (col of columnsDef; track col; let ci = $index) {
          <div
            [id]="col.field + '-col-header' | replace : '[,]' : '-'"
            class="header-col-title"
            [class.hidden-in-mobile]="col.hiddenInMobile"
            [style.flex]="col.widthPercent === undefined ? (ci > 0 ? '0 0 auto' : '1 1 auto') : '0 0 ' + col.widthPercent + '%'"
            [style.maxWidth]="col.widthPercent === undefined ? 'auto' : col.widthPercent + '%'"
            [style.justify-content]="col.alignment === undefined ? 'normal' : col.alignment"
            >
            @if (col.sortable && selectedRow === null) {
              <i
                class="fas"
                [class.fa-sort-up]="(col.isPrimarySort || multiColumnsSort) && col.sortDirection === 'asc'"
                [class.fa-sort-down]="(col.isPrimarySort || multiColumnsSort) && col.sortDirection === 'desc'"
                [class.fa-sort]="!col.isPrimarySort && !multiColumnsSort"
                [class.secondary]="!col.isPrimarySort"
                (click)="onSort(col)"
              ></i>
            }
            <span (click)="onSort(col)">
              {{ col.header }}
            </span>
          </div>
        }
      </div>
    </div>
  }
  @for (row of gridRows; track row; let i = $index) {
    <div
      [attr.id]="id + '-row-' + i"
      class="grid-panel-row"
      [ngClass]="row.selected ? 'selected' : !accordion && selectedRow !== null ? 'hidden' : ''"
      (click)="select(row, $event)"
      >
      @if (expandable) {
        <div class="toggle-col">
          @if (!row.selected) {
            <i class="fal fa-arrow-circle-right"></i>
          }
          @if (row.selected) {
            <i class="fal fa-times-circle" (click)="cancel($event)"></i>
          }
        </div>
      }
      <div class="row-content">
        @for (col of columnsDef; track col; let ci = $index) {
          <div
            [ngClass]="col.field + '-col' | replace : '[,]' : '-'"
            class="header-col"
            [class.hidden-in-mobile]="col.hiddenInMobile"
            [class.secondary-column]="ci > 0"
            [style.flex]="col.widthPercent === undefined ? (ci > 0 ? '0 0 auto' : '1 1 auto') : '0 0 ' + col.widthPercent + '%'"
            [style.maxWidth]="col.widthPercent === undefined ? 'auto' : col.widthPercent + '%'"
            [style.textAlign]="col.alignment === undefined ? 'auto' : col.alignment"
            >
            @if (col.customComponent && (col.shownWhenSelected || !row.selected)) {
              <ignite-grid-custom
                [component]="col.customComponent"
                [value]="row"
                [rowIndex]="i"
              ></ignite-grid-custom>
            }
            @if (!col.customComponent && (col.shownWhenSelected === undefined || col.shownWhenSelected || !row.selected)) {
              <span>{{
                getFieldValue(row, col.field, true, col.mapValueFunction)
              }}</span>
            }
          </div>
        }
      </div>
    </div>
  }

  @if (!useCustomForm) {
    <div #panelContent class="grid-row-details" [class.accordion]="accordion">
      @if (selectedRow !== null) {
        <ignite-form
          id="ignite-form"
          [name]="name"
          [fieldsDef]="fieldsDef"
          [readOnly]="readOnly || (addOnly && !isAddMode)"
          [data]="selectedRow"
          [isAddMode]="isAddMode"
          (addEvent)="addRow($event)"
          (editEvent)="editRow($event)"
          (cancelEvent)="cleanUp()"
        ></ignite-form>
      }
    </div>
  }
</div>
